import { takeLatest, all, put, call } from "redux-saga/effects";
import { authActionTypes } from "./auth.types";
import { signInFailure, signInSuccess, signOutFailure, signOutSuccess, signUpFailure, signUpSuccess } from "./auth.actions";

const mockUser = { id: '1', displayName: 'User', email: 'user@psflix.com' };

export function* signInWithGoogle() {
	try {
		yield put(signInSuccess(mockUser));
	} catch (e) {
		yield put(signInFailure(e.message));
	}
}

export function* signInWithEmail({payload: { email }}) {
	try {
		yield put(signInSuccess({ ...mockUser, email }));
	} catch (e) {
		yield put(signInFailure(e.message));
	}
}

export function* signInAnonymously() {
	try {
		yield put(signInSuccess(mockUser));
	} catch (e) {
		yield put(signInFailure(e.message));
	}
}

export function* checkIfUserIsAuthenticated(){
	try {
		yield put(signInSuccess(mockUser));
	} catch (e) {
		yield put(signInFailure(e.message));
	}
}

export function* signOut(){
	try {
		yield put(signOutSuccess());
	} catch (e) {
		yield put(signOutFailure(e.message));
	}
}

export function* signUp({payload: { displayName, email }}){
	try {
		yield put(signUpSuccess({ user: { ...mockUser, email }, additionalData: { displayName } }))
	} catch (e) {
		yield put(signUpFailure(e.message));
	}
}

export function* signInAfterSignUp({payload: { user, additionalData }}){
	yield put(signInSuccess({ ...user, ...additionalData }));
}

export function* onCheckUserSession(){
	yield takeLatest(authActionTypes.CHECK_USER_SESSION, checkIfUserIsAuthenticated);
}

export function* onGoogleSignInStart(){
	yield takeLatest(authActionTypes.GOOGLE_SIGN_IN_START, signInWithGoogle);
}

export function* onEmailSignInStart(){
	yield takeLatest(authActionTypes.EMAIL_SIGN_IN_START, signInWithEmail);
}

export function* onAnonymousSignInStart(){
	yield takeLatest(authActionTypes.ANONYMOUS_SIGN_IN_START, signInAnonymously);
}

export function* onSignOutStart(){
	yield takeLatest(authActionTypes.SIGN_OUT_START, signOut);
}

export function* onSignUpStart(){
	yield takeLatest(authActionTypes.SIGN_UP_START, signUp);
}

export function* onSignUpSuccess(){
	yield takeLatest(authActionTypes.SIGN_UP_SUCCESS, signInAfterSignUp);
}

export function* authSagas() {
	yield all([
		call(onCheckUserSession),
		call(onGoogleSignInStart),
		call(onEmailSignInStart),
		call(onAnonymousSignInStart),
		call(onSignOutStart),
		call(onSignUpStart),
		call(onSignUpSuccess),
	]);
}